export * from './baThemeSpinner.service';



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/services/baThemeSpinner/index.ts